import TextareaAutosize from 'react-textarea-autosize';
import styled from 'styled-components/macro';

import { palette, fontDefault, fontkoKR } from '@mirinae/react-ui';
import { os } from '@mirinae/js-utils/utils/userAgent';

export const inputElementsCommonStyle = `
    width: 100%;
    min-height: 50px;
    padding: 5px 30px;
    border: 1px solid ${palette.gray.light};
    border-radius: 25px;
    background-color: ${palette.white};
    color: ${palette.point.black};
    font-family: ${fontkoKR};
    font-weight: 500;
    font-size: 18px;
    text-align: center;
`;

export const InputArea = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    position: relative;
    width: 100%;

    .btn-audio {
        position: absolute;
        left: 20px;
    }
`;
export const AreaWrapper = styled.div`
    position: relative;
`;
export const EditableSourceText = styled.div`
    ${inputElementsCommonStyle};
    padding: 15px 0 63px;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    position: relative;
    min-height: 200px;
    box-shadow: 0 0 40px rgba(159, 188, 186, 0.2);
`;
export const EditableSourceTextarea = styled(TextareaAutosize)`
    display: block;
    width: 100%;
    border: 0;
    background: transparent;
    caret-color: ${palette.green.dark};
    color: ${palette.point.black};
    font-family: ${fontkoKR};
    font-weight: 400;
    font-size: 18px;
    min-height: 38px !important;
    overflow: hidden;
    text-align: center;
    line-height: 28px;
    padding: 0 15px;

    &::placeholder {
        color: #BFBFBF;
      font-family: ${fontDefault};
    }
`;
export const SourceText = styled.div`
    ${inputElementsCommonStyle};
    overflow: auto;
    cursor: pointer;
    padding: 10px 50px;
`;
export const ClearInput = styled.div`
    position: absolute;
    right: 0;
    bottom: 50%;
    width: 20px;
    height: 20px;
    margin-right: 15px;
    transform: translateY(10px);
`;

export const SourceSpan = styled.span`
    color: ${props => (props.analyzed ? '#a2d8d6' : '#dcd1e1')};
    
    &:hover  {
        color: ${props => (props.analyzed ? '#78a19d' : '#dcd1e1')};
    }
`;

export const ClauseSpan = styled.span`
    color: ${props => (palette.phraseType[props.clauseType] ? palette.phraseType[props.clauseType] : palette.phraseType.unknown).tree.dark};
    
    &:hover  {
        font-weight: 600;
    }
`;

export const TextSize = styled.div`
    position: absolute;
    right: ${os.isOthers ? '29px' : '19px'};
    bottom: ${os.isOthers ? '25px' : '14px'};
    color: ${props => (props.theme === 'danger' ? palette.warning.lighten[1] : palette.gray[5])};
    font-size: 15px;
    font-family: ${fontDefault};
`;

export const Romanization = styled.div`
    line-height: 24px;
    font-family: ${fontDefault};
    font-weight: 500;
    font-size: 14px;    
    text-align: center;
    margin-top: 10px;
    color: #BCBCBC;
`;